import { render, staticRenderFns } from "./Primer.vue?vue&type=template&id=26434d4c&scoped=true&"
import script from "./Primer.vue?vue&type=script&lang=js&"
export * from "./Primer.vue?vue&type=script&lang=js&"
import style0 from "./Primer.vue?vue&type=style&index=0&id=26434d4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26434d4c",
  null
  
)

export default component.exports